import {useStaticQuery, graphql} from "gatsby"

export const GetList = () => {
    const {allMarkdownRemark} = useStaticQuery(
        graphql`
        query listAeroplanes {
            allMarkdownRemark(filter: {fields: {collection: {eq: "aeroplanes"}}}) { 
                edges {
                  node {
                    frontmatter {
                      slug
                      title
                      brand
                      type
                      thumbnail {
                        childImageSharp {
                          fluid(maxWidth: 800) {
                                ...GatsbyImageSharpFluid_withWebp
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
        `
    )
    return allMarkdownRemark.edges;
}
